export const style = {
	handle: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
	},
};
